module.exports = "<div id=hire-me><p>Hi! If you think I am qualified, please send me an email: <strong>{{email}}</strong> with following details:</p><ul><li>Company Name and Location</li><li>Working Hours</li><li>Team Size</li><li>Job Scope</li><li>Job Requirements</li><li>Salary Offered</li><li>Staff Benefits</li></ul><p>And we shall discuss more later.</p><br><button class=\"btn btn-primary\" @click=copyToClipboard>Click Here to Copy My Email Address</button></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HireMe.vue
 ** module id = 222
 ** module chunks = 0
 **/